<div class="notFound">
  <div class="container">
    <div class="row">
      <div class="col-12 mt-4">
        <div style="text-align: center;">
          <img src="/assets/images/logo/new-logo-blue.svg" alt="" width="157" height="32">
        </div>
      </div>
      <div class="col-12" style="margin-top: 100px;">
        <div style="text-align: center;">
          <img src="/assets/images/503/server-down.png" alt="" width="391" height="280">
        </div>
      </div>
      <div class="col-12 mt-4 d-flex flex-column align-items-center">
        <span class="description">Website Fmarket tạm thời đang được nâng cấp</span>
        <span class="comback">Chúng tôi sẽ trở lại sớm nhất!!!</span>
      </div>
    </div>
  </div>
</div>